/* Aeehfeng v5 portrait: original and retouched visual illustration. */
(function(){
  'use strict';
  function init(){
    const hero=document.getElementById('aee-hero-comparison');
    const input=document.getElementById('aee-hero-compare-input');
    const after=document.getElementById('aee-hero-after');
    const line=document.getElementById('aee-hero-compare-line');
    const replay=document.getElementById('aee-hero-compare-replay');
    if(!hero||!input||!after||!line||!replay)return;
    const setProgress=(n)=>{
      const value=Math.max(0,Math.min(100,Number(n)||0));
      after.style.clipPath='inset(0 '+(100-value)+'% 0 0)';
      line.style.left=value+'%';
      input.value=String(value);
      input.setAttribute('aria-valuetext',Math.round(value)+'% of the visual illustration revealed');
    };
    input.addEventListener('input',()=>{
      hero.classList.add('is-manual');
      setProgress(input.value);
    });
    replay.addEventListener('click',()=>{
      hero.classList.remove('is-manual');
      after.style.removeProperty('clip-path');
      line.style.removeProperty('left');
      input.value='0';
      after.style.animation='none';line.style.animation='none';
      void after.offsetWidth;
      after.style.removeProperty('animation');line.style.removeProperty('animation');
    });
    input.addEventListener('keydown',(e)=>{
      if(e.key==='Home'||e.key==='End'||e.key.startsWith('Arrow')||e.key==='PageUp'||e.key==='PageDown'){
        hero.classList.add('is-manual');
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
